import type React from 'react';

import { Heading, Text } from '@zillow/constellation-10';

type Props = {
  heading: string;
  subheading: string | React.ReactNode;
  children: React.ReactNode;
};

const VerificationBodyTemplate = ({ children, heading, subheading }: Props) => (
  <>
    <Heading
      level={3}
      css={{
        marginBottom: '100',
        fontSize: '14px',
        fontWeight: 700,
        lg: {
          fontSize: '16px',
        },
      }}
    >
      {heading}
    </Heading>
    {typeof subheading === 'string' ? (
      <Text
        css={{
          fontSize: '14px',
          marginTop: '400',
          marginBottom: '200',
          lg: {
            fontSize: '16px',
            marginTop: '600',
            marginBottom: '400',
          },
        }}
      >
        {subheading}
      </Text>
    ) : (
      subheading
    )}
    {children}
  </>
);

export default VerificationBodyTemplate;
